module.exports = __webpack_public_path__ + "static/media/icon-total-1.4f28670b.svg";